import ajax from "./ajax";

export function getBannersByCategory(category) {
  return ajax(`/banners?BannersSearch[category]=${category}`);
}
